<template>
  <v-container fluid id="campaigns">
    <v-row class="justify-between align-center">
      <v-col cols="12" md="auto">
        <v-btn class="accent shadow-4 px-8" @click="openForm()" large rounded>
          Añadir campaña
        </v-btn>
      </v-col>

      <v-col cols="12" md="auto" class="ml-auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-chip-group
          mandatory
          v-model="statusFilter"
          active-class="success"
        >
          <span class="caption my-auto">Filtrar:</span>
          <!-- <v-chip class="mx-1" label :value="0">
            Todos
          </v-chip> -->
          <v-chip class="mx-1" label :value="true"> Vigentes </v-chip>

          <v-chip class="mx-1" label :value="false"> Vencidas </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-card class="shadow-1">
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="campaignList"
        :search="search"
        item-key="id"
        :server-items-length="totalEl"
        :options.sync="tableOptions"
        show-expand
        single-expand
      >
        <template v-slot:[`item.connect_crontad`]="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                color="transparent"
                small
                @click="changeStatus(item.id, item.connect_crontad)"
              >
                <v-icon left small :color="statusColor(item.connect_crontad)"
                  >mdi-radiobox-marked</v-icon
                >
                {{ item.connect_crontad | StatusCampaignName }}
              </v-chip>
            </template>
            <span>Conectar campaña</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.state`]="{ item }">
          <v-icon left small :color="statusColor(item.state)"
            >mdi-radiobox-marked</v-icon
          >
          {{
            item.state === 1
              ? "Encendida"
              : item.state === 2
              ? "Pausada"
              : "Apagada"
          }}
        </template>

        <!-- <template v-slot:[`item.type`]="{ item }">
                {{
                    campaignTypes.find(el => el.id === item.campaign_type_id)
                        .name
                }}
            </template> -->
        <template v-slot:[`item.action`]="{ item }">
          <!-- Open -->
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="goToCampaign(item)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>
          <!-- Edit -->
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="openForm(true, item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>
          <!-- Delete -->
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteAction(item.id)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>

        <template v-slot:expanded-item="{ item }">
          <td colspan="12">
            <v-row class="pl-15 ml-10 pt-8 pb-5">
              <!-- Hora de Inicio -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  Hora de Inicio:
                  <span class="text--primary">{{ item.start }}</span>
                </p>
              </v-col>
              <!-- Hora de Fin -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  Hora de Fin:
                  <span class="text--primary">{{ item.end }}</span>
                </p>
              </v-col>
              <!-- Reintentos -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  Reintentos:
                  <span class="text--primary">{{ item.retries }}</span>
                </p>
              </v-col>
              <!-- Conexión de campaña -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  Grabacion:
                  <span class="text--primary">{{ item.audio }}</span>
                </p>
              </v-col>
              <!-- url_response -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  URL de respuesta:
                  <span class="text--primary">{{ item.url_response }}</span>
                </p>
              </v-col>
              <!-- Fecha de creacion -->
              <v-col cols="4" class="py-0">
                <p class="info--text">
                  Fecha de creacion:
                  <span class="text--primary">{{ item.created_at }}</span>
                </p>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <create-dialog
      v-if="formDialog"
      :dialog="formDialog"
      :campaignTypesList="campaignTypes"
      :editMode="editMode"
      :data="itemToEdit"
      :axios="$axios"
      @dialog:close="callbackForm"
    ></create-dialog>
    <delete-dialog
      v-if="deleteDialog"
      :dialog="deleteDialog"
      :axios="$axios"
      :id="idToDelete"
      @dialog:close="deleteCallback"
    ></delete-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import CreateDialog from "@/components/Campaigns/Create";
import DeleteDialog from "@/components/Campaigns/Delete";

export default {
  components: {
    CreateDialog,
    DeleteDialog,
  },
  data() {
    return {
      isLoading: true,
      formDialog: false,
      deleteDialog: false,
      editMode: false,
      statusFilter: true,
      headers: [
        { text: "ID", value: "id", width: "5%" },
        { text: "Nombre", value: "name", width: "10%" },
        { text: "Inicio", value: "date_IN", width: "12%" },
        { text: "Fin", value: "date_EN", width: "12%" },
        // { text: "Audio", value: "queue_id", width: "10%" },
        { text: "Cola", value: "queue.name", width: "10%" },
        { text: "Numero Cola", value: "queue.number", width: "10%" },
        { text: "Tipo", value: "type_campaign.name", width: "10%" },
        { text: "Vol", value: "simultaneity", width: "5%" },
        // { text: "Reintentos", value: "retries", width: "5%" },
        { text: "Registros", value: "registers_count", width: "5%" },
        { text: "Estado", value: "connect_crontad", width: "12%" },
        // { text: "Estado", value: "state", width: "14%" },
        { text: "Acciones", value: "action", width: "15%" },
      ],
      campaignList: [],
      campaignTypes: [],
      tableOptions: {},
      search: "",
      page: 1,
      totalPage: 0,
      totalEl: 0,
      perPage: 0,
      pageCount: null,
      $axios: null,
      itemToEdit: null,
      idToDelete: null,
    };
  },
  created() {
    const token = localStorage.getItem("token");
    this.$axios = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI,
      headers: { Authorization: `Bearer ${token}` },
    });
    this.getCampaignsTypes();
  },
  watch: {
    tableOptions: {
      handler() {
        this.getCampaigns();
      },
      deep: true,
    },

    statusFilter() {
      this.getCampaigns();
      // this.getCampaignsTypes();
    },
  },
  methods: {
    statusColor(status) {
      let color;

      switch (status) {
        case 1:
          color = "success";

          break;

        case 2:
          color = "light-blue";

          break;

        default:
          color = "grey";

          break;
      }
      return color;
    },

    async changeStatus(id, value) {
      try {
        const newStatus = value === 1 ? 0 : 1;
        const { data } = await PbxHttpClient.get(
          `/campaign/active_campaign/${id}?status=${newStatus}`
        );
        this.getCampaigns();
        // console.log("Campaigns types:", data);
      } catch (err) {
        this.$snotify.error(err.response.data.error, "¡Error!");
        // console.log("error getting campaigns types:", err);
      }
      this.isLoading = false;
    },

    async getCampaigns() {
      this.isLoading = true;
      try {
        const page = this.tableOptions.page || 1;
        const itemPerPage = this.tableOptions.itemsPerPage || 10;
        const { data } = await PbxHttpClient.get(`/campaign/campaign`, {
          params: { page, itemPerPage, vigente: this.statusFilter },
        });
        this.campaignList = data.data;
        this.totalPage = data.last_page;
        this.totalEl = data.total;
        this.perPage = data.per_page;
      } catch (err) {
        console.log("Error getting campaigns:", err);
      }
      this.isLoading = false;
    },

    async getCampaignsTypes() {
      try {
        const { data } = await PbxHttpClient.get(
          "/campaign/campaign_type/get_all"
        );
        this.campaignTypes = data.data;
        // console.log("Campaigns types:", data);
      } catch (err) {
        this.$snotify.error("Hubo un error consiguiendo los datos", "¡Error!");
        console.log("error getting campaigns types:", err);
      }
      this.isLoading = false;
    },
    openForm(editMode = false, item = null) {
      this.editMode = editMode;
      if (editMode) this.itemToEdit = item;
      this.formDialog = true;
    },
    deleteAction(id) {
      this.idToDelete = id;
      this.deleteDialog = true;
    },
    callbackForm(item = null) {
      if (item && !this.editMode)
        this.campaignList = [...this.campaignList, item];
      if (item && this.editMode)
        this.campaignList = this.campaignList.map((el) =>
          el.id === item.id ? item : el
        );
      this.formDialog = false;
      this.editMode = false;
      // console.log("return form...");
    },
    deleteCallback(id = null) {
      if (id)
        this.campaignList = this.campaignList.filter((el) => el.id !== id);
      this.deleteDialog = false;
    },
    goToCampaign(item) {
      this.$router.push(`/campaigns/${item.id}`);
    },
  },
};
</script>

<style></style>
